/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function DeviceGroupTableConfig($q, $translate, $mdDialog, $document, $state, toast, types, utils, tkDialogs, userService,
                                           deviceGroupService, networkSettingsService, apiLimitsService, subCustomerService) {

    var service = {
        getConfig: getConfig
    };

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        if (params.subCustomerId) {
            subCustomerService.getSubCustomer(params.subCustomerId).then(
                (subCustomer) => {
                    var tableConfiguration = createDeviceGroupConfig(scope, access, params, subCustomer.title);
                    deferred.resolve(tableConfiguration);
                },
                () => {
                    deferred.reject();
                }
            );
        } else {
            var tableConfiguration = createDeviceGroupConfig(scope, access, params);
            deferred.resolve(tableConfiguration);
        }
        return deferred.promise;
    }

    function createDeviceGroupConfig(scope, access, params, entityTitle) {

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var subCustomerId;

        if (params.subCustomerId) {
            subCustomerId = params.subCustomerId;
        } else {
            subCustomerId = currentUser.subCustomerId;
        }

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.deviceGroup,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'name',
                    title: 'device-group.name'}
            ],

            addEntityController: 'AddDeviceGroupController',

            loadEntities: () => {return scope == types.scope.customer && !params.subCustomerId
                ? deviceGroupService.getCustomerDeviceGroups()
                : deviceGroupService.getSubCustomerDeviceGroups(subCustomerId)},
            loadEntity: (entityId) => {return loadDeviceGroup(entityId)},
            saveEntity: (entity) => {return saveDeviceGroup(entity)},
            deleteEntity: (entityId) => {return deviceGroupService.deleteDeviceGroup(entityId)},

            addEnabled: () => {
                return access == types.access.admin;
            },
            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('device-group.delete-device-group-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('device-group.delete-device-group-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('device-group.delete-device-groups-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('device-group.delete-device-groups-text');
            }

        };

        if (!params.subCustomerId && scope == types.scope.customer) {
            tableConfiguration.columns.push(
                {
                    key: 'subCustomerTitle',
                    title: 'device-group.assigned-subCustomer'
                }
            );
        }

        tableConfiguration.manageCredentials = (event, entity) => {
            var isReadOnly = access == types.access.user ? true : false;
            manageCredentials(event, entity, isReadOnly);
        };

        tableConfiguration.manageDevices = (event, entity) => {
            manageDevices(event, params.subCustomerId, entity);
        };

        tableConfiguration.actionCellDescriptors = [
            {
                name: 'device-group.assign-to-subCustomer',
                icon: 'assignment_ind',
                isEnabled: (entity) => {
                    return entity && (authority === types.authority.CUSTOMER_ADMIN.value && !params.subCustomerId && !entity.subCustomerId);
                },
                onAction: ($event, entity) => {
                    assignToCustomer($event, entity, tableConfiguration);
                }
            },
            {
                name: 'device-group.unassign-from-subCustomer',
                icon: 'assignment_return',
                isEnabled: (entity) => {
                    return entity && (authority === types.authority.CUSTOMER_ADMIN.value && (params.subCustomerId || entity.subCustomerId));
                },
                onAction: ($event, entity) => {
                    unassignFromCustomer($event, entity, tableConfiguration);
                }
            },
            {
                name: access == types.access.admin ? 'credentials.manage' : 'credentials.view',
                icon: 'security',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    var isReadOnly = types.adminAuthorities.indexOf(authority) === -1 ? true : false;
                    manageCredentials($event, entity, isReadOnly);
                }
            },
            {
                name: 'device-group.manage-devices',
                icon: 'devices_other',
                isEnabled: () => {
                    return true;
                },
                onAction: ($event, entity) => {
                    manageDevices($event, params.subCustomerId, entity);
                }
            }
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('device-group.device-groups');

        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function manageCredentials($event, deviceGroup, isReadOnly) {
        tkDialogs.manageCredentials($event, deviceGroup, isReadOnly);
    }

    function manageDevices($event, subCustomerId, deviceGroup) {
        if ($event) {
            $event.stopPropagation();
        }
        if (subCustomerId) {
            $state.go('home.subCustomers.deviceGroups.devices', {subCustomerId: subCustomerId, applicationId: deviceGroup.id.id});
        } else {
            $state.go('home.deviceGroups.devices', {applicationId: deviceGroup.id.id});
        }
    }

    function assignToCustomer($event, deviceGroup, tableConfiguration) {
        var onEntitySelected = (targetSubCustomerId) => {
            return deviceGroupService.assignDeviceGroupToSubCustomer(targetSubCustomerId.id, deviceGroup.id.id);
        };
        tkDialogs.selectEntity($event, types.entityType.subCustomer,
            'device-group.assign-device-group', 'action.assign',
            'device-group.select-target-assign-subCustomer-text',
            'subCustomer.subCustomer-not-found-text',
            'subCustomer.target-subCustomer-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function unassignFromCustomer($event, deviceGroup, tableConfiguration) {
        var title = $translate.instant('device-group.unassign-device-group-title', {deviceGroupName: deviceGroup.name});
        var content = $translate.instant('device-group.unassign-device-group-text');
        var label = $translate.instant('device-group.unassign-device-group');

        tkDialogs.confirm($event, title, content, label).then(
            () => {
                deviceGroupService.unassignDeviceGroupFromSubCustomer(deviceGroup.id.id).then(
                    () => { tableConfiguration.reloadEntities(true); }
                );
            }
        );
    }

    function loadDeviceGroup(applicationId) {
        var deferred = $q.defer();
        deviceGroupService.getDeviceGroup(applicationId).then(
            (deviceGroup) => {
                networkSettingsService.getNetworkSettings(types.entityType.deviceGroup, applicationId).then(
                    (networkSettings) => {
                        deviceGroup.networkSettings = networkSettings;
                        apiLimitsService.getApiLimits(types.entityType.deviceGroup, applicationId).then(
                            (apiLimits) => {
                                deviceGroup.apiLimits = apiLimits;
                                deferred.resolve(deviceGroup);
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveDeviceGroup(deviceGroup) {
        var deferred = $q.defer();
        var networkSettings = deviceGroup.networkSettings;
        var apiLimits = deviceGroup.apiLimits;
        deviceGroupService.saveDeviceGroup(deviceGroup).then(
            (deviceGroup) => {
                networkSettingsService.saveNetworkSettings(networkSettings).then(
                    (networkSettings) => {
                        deviceGroup.networkSettings = networkSettings;
                        apiLimitsService.saveApiLimits(apiLimits).then(
                            (apiLimits) => {
                                deviceGroup.apiLimits = apiLimits;
                                deferred.resolve(deviceGroup);
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/device-group/device-group-table.config.js